import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Subject, combineLatest } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { MyQuotesService } from 'src/app/services/feature/myQuotes/my-quotes.service';
import { KbGetAQuoteService } from '../../kb-Get-A-Quote/kb-get-aquote/kb-get-aquote.service';

@Component({
  selector: 'app-my-quotes-list',
  templateUrl: './my-quotes-list.component.html',
  styleUrls: ['./my-quotes-list.component.scss'],
  standalone: false
})
export class MyQuotesListComponent {
  quoteListDetails: any;
  private destroy$ = new Subject<void>();
  totalResults: any;
  pageItems: any
  quoteListForm = new FormGroup(
    {
      customerId: new FormControl(null),
    }
  );
  constructor(private myQuotesService: MyQuotesService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private translateService: TranslationService,
    private customerIdService: CustomerIdService,
    private globalMessageService: GlobalMessageService,
    private quoteService: KbGetAQuoteService) {

  }

  ngOnInit() {
    if (this.quoteService.globalMsg) {
      const key: string = this.quoteService.cancelMsg ? this.quoteService.globalMsg : { key: this.quoteService.globalMsg };
      this.globalMessageService.add(key, GlobalMessageType.MSG_TYPE_INFO);
    }
    this.customerIdService.theCurrentCustomerIdState$.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((x) => {
      if (x && x.uid) {
        this.getQuoteList(x.uid);
        this.quoteListForm.controls['customerId'].setValue(x.uid);
      }
    })
    this.myQuotesService.cancelQuoteMsg.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.globalMessageService.add(
          res,
          GlobalMessageType.MSG_TYPE_INFO
        );
      }
    })

  }

  searchQuote() {
    this.getQuoteList(this.quoteListForm.controls['customerId'].value);
  }

  getQuoteList(unitId, pageSize?) {
    this.myQuotesService.getMyQuotesList(unitId, pageSize).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.quoteListDetails = data;
      combineLatest([

        this.translateService.translate('common.text_account_quote_page_totalResultsSinglePag'), this.translateService.translate('common.text_account_core_search_totalResultsCurrPage')
      ]).pipe(takeUntil(this.destroy$)).subscribe(([res1, res2]: any) => {
        this.totalResults = res1.replace('{0}', data.pagination?.totalResults);

        if (data.pagination?.currentPage == 0) {
          this.pageItems = res2.replace('{1}', data.pagination?.totalResults).replace('{0}', (data.pagination?.pageSize * data.pagination?.currentPage) + 1 + '-' + data.pagination?.pageSize * (data.pagination?.currentPage + 1))
        } else if (data.pagination.currentPage > 0) {
          this.pageItems = res2.replace('{1}', data.pagination?.totalResults).replace('{0}', (data.pagination?.pageSize * data.pagination?.currentPage) + 1 + '-' + data.pagination?.pageSize * (data.pagination?.currentPage + 1));
        }
        this.cdr.detectChanges();
      })
      this.quoteListForm.controls['customerId'].setValue(this.quoteListForm.controls['customerId'].value);
      this.cdr.detectChanges();
    })
  }

  redirectOrder(item) {

    this.router.navigate(["my-quotes", item.code]);
  }


  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    if (format) {
      return `${year}${month}${day}`
    }

    return `${day}.${month}.${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  changePageCustom(e) {
    this.getQuoteList(this.quoteListForm.controls['customerId'].value, e);
  }

  ngOnDestroy() {
    this.quoteService.globalMsg = undefined;
    this.destroy$.next();
    this.destroy$.complete();

  }
}
